import './dynamic-image-style.scss'

import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import _ from 'lodash'
import React from 'react'

import NoImage from '../no-image/no-image'
import ImageTag from '../tag/image-tag'

const DynamicImage = ({ item }) => {
  const image = getImage(_.get(item, 'featuredImage.node.localFile', undefined))

  return (
    <figure className="card-image">
      <div>
        {image ? (
          <GatsbyImage
            image={image}
            alt="Crypto"
            loading="eager"
            imgStyle={{ objectFit: 'contain' }}
          />
        ) : (
          <NoImage />
        )}
        <ImageTag article={item} />
      </div>
    </figure>
  )
}

export default DynamicImage
